<script lang="ts">
  import { isConnected } from "../lib/socketManager";
</script>

<!-- Online indicator dot -->
<div class="online-indicator" class:online={$isConnected}></div>

<style>
  .online-indicator {
    position: fixed;
    top: 4px;
    right: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgb(222, 4, 4); /* Offline color */
    z-index: 1000;
  }
  .online-indicator.online {
    background-color: green; /* Online color */
  }
</style>
